import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Injectable({
  providedIn: 'root',
})
export class AcmicGuard implements CanActivate {
  constructor(private acmicService: AcmicService, private router: Router) {}

  canActivate(): boolean {
    if (this.acmicService.isACMIC()) {
      return true;
    }
    this.router.navigate(['/make-payment']);
    return false;
  }
}
